import { cellHTMLCache, Rows } from '../index';
import { Cell, Row } from '../types';

export function exportTableCellsToHTML(
  rows: Rows,
  rect?: { startX: number; endX: number; startY: number; endY: number },
): HTMLElement {
  const table = document.createElement('table');
  table.classList.add('rte__table');
  const colGroup = document.createElement('colgroup');
  const tBody = document.createElement('tbody');
  const firstRow = rows[0] as Row;

  for (let x = rect != null ? rect.startX : 0; x < (rect != null ? rect.endX + 1 : firstRow.cells.length); x++) {
    const col = document.createElement('col');
    colGroup.append(col);
  }

  for (let y = rect != null ? rect.startY : 0; y < (rect != null ? rect.endY + 1 : rows.length); y++) {
    const row = rows[y] as Row;
    const cells = row.cells;
    const rowElem = document.createElement('tr');

    for (let x = rect != null ? rect.startX : 0; x < (rect != null ? rect.endX + 1 : cells.length); x++) {
      const cell = cells[x] as Cell;
      const isHeader = cell?.type === 'header';
      const cellElem = document.createElement(isHeader ? 'th' : 'td');
      cellElem.innerHTML = cellHTMLCache.get(cell.json) || '';
      cellElem.classList.add('rte__tableCell');
      isHeader && cellElem.classList.add('rte__tableCellHeader');
      rowElem.appendChild(cellElem);
    }
    tBody.appendChild(rowElem);
  }

  table.appendChild(colGroup);
  table.appendChild(tBody);
  return table;
}
